import axios from 'axios';
import { JsonEncoded } from '../../services/types/Misc';

const instance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_API,
  headers: { Pragma: 'no-cache' },
});

instance.interceptors.request.use((req) => {
  if (req.data && (req.method === 'post' || req.method === 'put')) {
    req.headers['X-ESG-COMPASS-REQ-CODIFICATION'] = 'base64';
    if (req.data instanceof FormData) {
      const formData = req.data as FormData;
      const dataForm = new FormData();
      Array.from(formData.entries()).forEach((x) => {
        const key = x[0];
        const value = x[1];
        if (value instanceof File) {
          dataForm.append(key, value);
        } else {
          const base64Value = Buffer.from(value).toString('base64');
          dataForm.append(key, base64Value);
        }
        req.data = dataForm;
      });
    } else {
      req.data = {
        payload: Buffer.from(JSON.stringify(req.data)).toString('base64'),
      } as JsonEncoded;
      req.headers['Content-Type'] = 'application/json';
    }
  }
  return req;
});

export default instance;
